import styled from '@emotion/styled';
import { Table, Td, Th } from '@lightspeed/cirrus-table';
import { Alert } from '@lightspeed/flame/Alert';
import { Button } from '@lightspeed/flame/Button';

export const NO_IMAGE_URL = 'https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/b2b/no_image_50.svg';

export const ListingTH = styled(Th)`
  &&& {
    color: #5c626a;
    font-size: 14px;
    font-weight: 400;
    height: 28px;
    padding: 0 1.125rem;
  }
`;

export const ListingTD = styled(Td)`
  &&& {
    vertical-align: top;
    background: #fff;
    img {
      height: auto;
      width: auto;
      max-width: 50px;
      max-height: 50px;
    }
  }
`;

export const MatrixListingTH = styled(Th)`
  &&& {
    font-size: 14px;
    height: 28px;
    padding: 18px;
    background: #fff;
  }
`;

export const MatrixListingCheckTH = styled(Th)`
  &&& {
    font-size: 14px;
    height: 28px;
    padding: 18px 31px 18px 52px;
    background: #fff;
  }
`;

export const MatrixListingTD = styled(Td)`
  &&& {
    vertical-align: middle;
    background: #fff;
    padding: 4px 18px;
    img {
      height: auto;
      width: auto;
      max-width: 40px;
      max-height: 40px;
    }
  }
`;

export const StyledAlert = styled(Alert)`
  border-top: 0;
  border-bottom: 1px solid #ccc;
  a {
    display: inline-block;
    margin-top: 1rem;
  }
  h3 {
    font-size: 16px;
  }
  img {
    // flex gap doesn't work yet for Flame's flex component
    margin-left: 1.5rem;
  }
`;

export const TableInCard = styled(Table)`
  border-top: 1px solid #e6e6e6;
`;
